import { render, staticRenderFns } from "./AddLabModal.vue?vue&type=template&id=3b8d3b85&"
import script from "./AddLabModal.vue?vue&type=script&lang=js&"
export * from "./AddLabModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports